const fragment = `
  id
  event
  status
  requestBody
  responseBody
  responseStatusCode
  responseError
  processedAt
`;

export const listWebhookDeliveriesQuery = `
  query ListWebhookDeliveries(
    $filter: WebhookDeliveryFilterInput
  ) {
    items: listWebhookDeliveries(filter: $filter) {
      ${fragment}
    }
  }
`;

export const getWebhookDeliveryQuery = `
  query GetWebhookDelivery($id: Int!) {
    item: getWebhookDelivery(id: $id) {
      ${fragment}
    }
  }
`;

export const deleteWebhookDeliveryQuery = `
  mutation DeleteWebhookDelivery(
    $id: Int!
  ) {
    item: deleteWebhookDelivery(id: $id) {
      ${fragment}
    }
  }
`;
